import { z } from 'zod';
import { moneySchema, type MoneyDto } from '../money';

/** EK-Staffelpreis: ab `minQuantity` gilt `price` (ADR 0009). */
export const createPriceTierSchema = z.object({
  minQuantity: z.number().positive(),
  price: moneySchema,
});
export type CreatePriceTierInput = z.infer<typeof createPriceTierSchema>;

export const priceTierResponseSchema = z.object({
  id: z.string().uuid(),
  articleId: z.string().uuid(),
  minQuantity: z.number(),
  price: moneySchema,
  createdAt: z.string().datetime(),
});
export type PriceTierResponse = z.infer<typeof priceTierResponseSchema>;

/**
 * Liefert den EK-Preis für eine Menge: höchste Staffel mit `minQuantity` ≤ Menge,
 * sonst der Basispreis (Fallback). Pure Funktion — von Front- und Backend genutzt.
 */
export function priceForQuantity(
  tiers: Pick<PriceTierResponse, 'minQuantity' | 'price'>[],
  quantity: number,
  basePrice: MoneyDto | null,
): MoneyDto | null {
  const applicable = tiers
    .filter((tier) => tier.minQuantity <= quantity)
    .sort((a, b) => b.minQuantity - a.minQuantity);
  return applicable[0]?.price ?? basePrice;
}
